import React, { Component } from "react";
import { Spin } from "antd";
import Swal from "sweetalert2";
import "../ORDER/OrderMaster/style.css";
import "antd/dist/antd.css";

const API = "https://api.blumangoes.ai:6143/";
const DB  = "IMAGEDB";

export default class frmExcelImageEnricher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      excelFile:      null,
      selectedCategory: "",
      urlColumn:      "",
      headers:        [],       // columns parsed from the uploaded file
      loading:        false,
      jobId:          null,
      progress:       null,     // { current, total }
    };
    this.fileInputRef = React.createRef();
    this.pollInterval = null;
  }

  componentWillUnmount() {
    if (this.pollInterval) clearInterval(this.pollInterval);
  }

  // ── After file chosen: parse headers from server ─────────────────────────
  handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    this.setState({ excelFile: file, headers: [], urlColumn: "" });

    const token = localStorage.getItem("authToken1") || "";
    const form  = new FormData();
    form.append("excel_file", file);

    try {
      const res = await fetch(`${API}get-excel-headers?db=${DB}`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: form,
      }).then(r => r.json());

      if (res.headers && res.headers.length) {
        // Auto-select first column whose name looks like an image URL column
        const autoUrl = res.headers.find(h =>
          /image.*url|url.*image|img.*link|link.*img|image\s*\d|photo.*url/i.test(h)
        ) || "";
        this.setState({ headers: res.headers, urlColumn: autoUrl });
      }
    } catch {
      // non-fatal — user can type the column name manually
    }
  };

  // ── Polling ───────────────────────────────────────────────────────────────
  pollStatus = (jobId, token) => {
    this.pollInterval = setInterval(async () => {
      try {
        const data = await fetch(`${API}job-status/${jobId}?db=${DB}`, {
          headers: { Authorization: `Bearer ${token}` },
        }).then(r => r.json());

        const state = (
          data.status || data.job_status || data.state ||
          (data.data && data.data.status) || ""
        ).toLowerCase();

        if (data.current !== undefined) {
          this.setState({ progress: { current: data.current, total: data.total || "?" } });
        }

        if (state === "completed" || state === "success") {
          clearInterval(this.pollInterval);
          this.downloadResult(jobId, token);
        } else if (state === "failure" || state === "failed") {
          clearInterval(this.pollInterval);
          this.setState({ loading: false });
          Swal.fire("Error", data.error || "Processing failed", "error");
        }
      } catch { /* keep polling */ }
    }, 5000);
  };

  // ── Download enriched Excel ───────────────────────────────────────────────
  downloadResult = async (jobId, token) => {
    try {
      const response = await fetch(`${API}download/${jobId}?db=${DB}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const blob = await response.blob();
      const url  = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "enriched_metadata.xlsx";
      document.body.appendChild(link);
      link.click();
      link.remove();
      this.setState({ loading: false, progress: null });
      Swal.fire({
        icon: "success",
        title: "Done!",
        text: "Enriched Excel downloaded successfully.",
      });
    } catch {
      this.setState({ loading: false });
      Swal.fire("Error", "Download failed", "error");
    }
  };

  // ── Submit ────────────────────────────────────────────────────────────────
  handleSubmit = async () => {
    const { excelFile, selectedCategory, urlColumn } = this.state;
    const token = localStorage.getItem("authToken1");

    if (!token) {
      Swal.fire("Unauthorized", "Please login again.", "error");
      return;
    }
    if (!excelFile) {
      Swal.fire("Warning", "Please upload an Excel file.", "warning");
      return;
    }
    if (!selectedCategory) {
      Swal.fire("Warning", "Please select a category.", "warning");
      return;
    }
    if (!urlColumn.trim()) {
      Swal.fire("Warning", "Please select or enter the Image URL column name.", "warning");
      return;
    }

    this.setState({ loading: true, progress: null });

    try {
      const form = new FormData();
      form.append("excel_file",  excelFile);
      form.append("category",    selectedCategory);
      form.append("url_column",  urlColumn.trim());

      const data = await fetch(`${API}process-excel-images?db=${DB}`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: form,
      }).then(r => r.json());

      if (data.error) throw new Error(data.error);
      if (!data.job_id) throw new Error("Job ID missing in response");

      this.setState({ jobId: data.job_id });
      this.pollStatus(data.job_id, token);
    } catch (err) {
      this.setState({ loading: false });
      Swal.fire("Error", err.message, "error");
    }
  };

  // ── Render ────────────────────────────────────────────────────────────────
  render() {
    const { excelFile, selectedCategory, urlColumn, headers, loading, progress } = this.state;

    const spinTip = progress
      ? `Processing image ${progress.current} of ${progress.total}…`
      : "Submitting job, please wait…";

    return (
      <div className="content-wrapper">
        {loading && (
          <div className="loader">
            <div className="loader-item" style={{ marginLeft: "75vh" }}>
              <Spin tip={spinTip} />
            </div>
          </div>
        )}

        <section className="content">
          <div className="box box-success" style={{ marginTop: "-13px" }}>
            <div className="box-header with-border" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '12px 20px' }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 11, color: '#aaa', marginBottom: 3 }}>
                  Dashboard &gt; Image Tools &gt; Excel Image Enricher
                </div>
                <h3 className="box-title" style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>
                  EXCEL IMAGE METADATA ENRICHER
                </h3>
              </div>
              <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginTop: 4, flexWrap: 'wrap' }}>
              </div>
            </div>

            <div className="box-body">
              <div className="row">

                {/* Excel file upload */}
                <div className="col-xs-12 col-sm-5 col-md-5 margintop">
                  <label>Upload Excel File *</label>
                  <input
                    type="file"
                    className="form-control"
                    accept=".xlsx,.xlsm"
                    ref={this.fileInputRef}
                    onChange={this.handleFileChange}
                  />
                  {excelFile && (
                    <small style={{ color: "#52c41a" }}>✓ {excelFile.name}</small>
                  )}
                </div>

                {/* Category */}
                <div className="col-xs-12 col-sm-3 col-md-3 margintop">
                  <label>File Category *</label>
                  <select
                    className="form-control"
                    value={selectedCategory}
                    onChange={e => this.setState({ selectedCategory: e.target.value })}
                  >
                    <option value="">--Select Category--</option>
                    <option value="footwear">Footwear</option>
                    <option value="apparel">Apparel</option>
                  </select>
                </div>

                {/* URL column — dropdown if headers loaded, else text input */}
                <div className="col-xs-12 col-sm-4 col-md-4 margintop">
                  <label>Image URL Column *</label>
                  {headers.length > 0 ? (
                    <select
                      className="form-control"
                      value={urlColumn}
                      onChange={e => this.setState({ urlColumn: e.target.value })}
                    >
                      <option value="">-- Select column --</option>
                      {headers.map(h => (
                        <option key={h} value={h}>{h}</option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type="text"
                      className="form-control"
                      placeholder="e.g. Image URL"
                      value={urlColumn}
                      onChange={e => this.setState({ urlColumn: e.target.value })}
                    />
                  )}
                  <small style={{ color: "#888" }}>
                    Column in your Excel that contains image URLs
                  </small>
                </div>

                {/* Info box */}
                <div className="col-xs-12 margintop">
                  <div style={{
                    background: "#f6ffed", border: "1px solid #b7eb8f",
                    borderRadius: 4, padding: "8px 14px", fontSize: 12, color: "#389e0d",
                  }}>
                    <strong>How it works:</strong> The system reads each image URL from your
                    Excel, fetches the image, runs AI analysis (same as Image Metadata Generator),
                    then writes the result columns back into your sheet. Columns that already have
                    values are never overwritten. Only blank cells are filled.
                  </div>
                </div>

                {/* Submit */}
                <div className="col-xs-12" style={{ marginTop: 30 }}>
                  <div className="text-center">
                    <button
                      className="btn btn-primary btn-lg"
                      onClick={this.handleSubmit}
                      disabled={loading}
                    >
                      ENRICH METADATA
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
